export default "__VITE_ASSET__6883a35a__"